import React from "react";
import { useCloseBACSRun, invalidateBACSRun } from "./api";
import { useHistory } from "react-router-dom";
import { publish } from "./pubSub";

import { PanelDialog, PanelActions, Button, PanelRow, PanelHeading } from "@backslashbuild/pp-ui";

export default function CloseDialog({ open, onClose, bacsRunId }) {
  const history = useHistory();
  const post = useCloseBACSRun();

  async function handleConfirm() {
    const res = await post({ bacsRunId });

    if (res.isSuccess) {
      publish("notification", "Success! The bacs run has been closed.");
      invalidateBACSRun();
      history.push("/bacs-runs");
    } else {
      publish(
        "notification",
        <div>
          Attempt Failed
          <ul>
            {res?.errors?.map((error) => (
              <li>{error}</li>
            ))}
          </ul>
        </div>
      );
    }
  }

  return (
    <PanelDialog open={open} onClose={onClose}>
      <PanelHeading>Close BACS Run</PanelHeading>
      <PanelRow>
        <p>
          Click on 'Confirm' to permanently close this BACS Run. You will be taken back to the BACS
          Runs page. This BACS Run will no longer be eligible for CSV exports.
        </p>
      </PanelRow>
      <PanelActions>
        <Button variant="secondary" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            handleConfirm();
            onClose();
          }}
        >
          Confirm
        </Button>
      </PanelActions>
    </PanelDialog>
  );
}
